"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Styles = require("./Styles");
var _InfoDisplayWrapper = require("../../../shared/utility-components/InfoDisplayWrapper");
var _reactUse = require("react-use");
var _InnerButton = require("../buttons/InnerButton");
var _ComboboxStyles = require("../combobox/supportcomponents/ComboboxStyles");
var _TextField = _interopRequireDefault(require("../../../components/inputs/input/TextField"));
var _Text = _interopRequireDefault(require("../../../components/text/Text"));
var _DropdownListWrapper = require("../combobox/supportcomponents/DropdownListWrapper");
var _input = require("../../../components/inputs/input/input.tokens");
var _Option = require("../combobox/supportcomponents/Option");
var _useMultiComboboxController = require("./useMultiComboboxController");
var _Icon = require("../../media/icon/Icon");
var _styledComponents = require("styled-components");
var _colorUtils = require("../../../shared/colorUtils");
var _jsxRuntime = require("react/jsx-runtime");
function SectionHeader(props) {
  var _props$item$section;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Styles.SectionHeaderStyles, _objectSpread({}, props, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      children: (_props$item$section = props.item.section) === null || _props$item$section === void 0 ? void 0 : _props$item$section.name
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: props.sectionVisible ? 'chevronDown' : 'chevronUp'
    })]
  }));
}
function MultiCombobox(_ref) {
  var items = _ref.items,
    selectedKeys = _ref.selectedKeys,
    setSelectedKeys = _ref.setSelectedKeys,
    label = _ref.label,
    helperText = _ref.helperText,
    errorText = _ref.errorText,
    showErrorAsIconTooltip = _ref.showErrorAsIconTooltip,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? _TextField.default.SIZE.LARGE : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? _input.TextFieldWidth.FIXED : _ref$width,
    disabled = _ref.disabled,
    children = _ref.children,
    dataCy = _ref['data-cy'];
  var _ref2 = (0, _useMultiComboboxController.useMultiComboboxController)(items, selectedKeys, setSelectedKeys),
    menuItems = _ref2.menuItems,
    inputValue = _ref2.inputValue,
    shouldRenderSectionHeader = _ref2.shouldRenderSectionHeader,
    selectedItems = _ref2.selectedItems,
    isOpen = _ref2.isOpen,
    toggleButtonProps = _ref2.toggleButtonProps,
    inputProps = _ref2.inputProps,
    getLabelProps = _ref2.getLabelProps,
    getMenuProps = _ref2.getMenuProps,
    elementHasFocus = _ref2.elementHasFocus,
    getItemProps = _ref2.getItemProps,
    getHeaderProps = _ref2.getHeaderProps,
    getSelectedItemProps = _ref2.getSelectedItemProps,
    removeSelectedItem = _ref2.removeSelectedItem;
  var _ref3 = (0, _reactUse.useMeasure)(),
    _ref4 = _slicedToArray(_ref3, 2),
    measureRef = _ref4[0],
    measurements = _ref4[1];
  var itemRenderer = children;
  var theme = (0, _styledComponents.useTheme)();
  var menuProps = getMenuProps();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Styles.MultiComboboxWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InfoDisplayWrapper.InfoDisplayWrapper, {
      label: label,
      ariaLabelProps: getLabelProps(),
      helperText: helperText,
      errorText: errorText,
      showErrorAsIconTooltip: showErrorAsIconTooltip,
      "data-cy": dataCy,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Styles.MultiLineStyledControlWrapper, {
        height: height,
        width: width,
        isFocused: isOpen,
        ref: measureRef,
        disabled: disabled,
        hasError: !!errorText,
        className: 'multiComboboxControl',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Styles.MultiLineWrapper, {
          height: height,
          onClick: !isOpen ? toggleButtonProps.onClick : undefined,
          "data-cy": dataCy + '-selected-items',
          children: [selectedItems.map(function (selectedItem, index) {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Styles.SelectedItem, _objectSpread({}, getSelectedItemProps({
              selectedItem: selectedItem,
              index: index
            }), {
              onClick: function onClick(e) {
                e.stopPropagation();
              },
              color: selectedItem.color,
              height: height,
              children: [itemRenderer && selectedItem && itemRenderer(selectedItem, {
                isSelection: true
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Styles.RemoveItemButton, {
                onClick: function onClick(e) {
                  e.stopPropagation();
                  removeSelectedItem(selectedItem);
                },
                "data-cy": (0, _useMultiComboboxController.getItemDataCy)(dataCy, 'remove', selectedItem),
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                  icon: 'close',
                  customColor: (0, _colorUtils.getTextColor)(selectedItem.color, theme)
                })
              })]
            }), "selected-item-".concat(index));
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ComboboxStyles.MultiComboBoxInput, _objectSpread({
            sizeKey: height,
            size: isOpen ? inputValue.length + 1 : 1
          }, inputProps, {
            "data-cy": dataCy + '-input'
          }))]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Styles.ComboboxDivider, {
          className: 'multiComboboxControl',
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.StyledInnerButton, _objectSpread({}, toggleButtonProps, {
            "aria-label": 'toggle menu',
            width: _input.tokens.size.height[height],
            "data-cy": dataCy + '-toggle',
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              icon: 'chevronDown'
            })
          }))
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownListWrapper.DropdownListWrapperMultiCombobox, {
        width: measurements.width + 'px',
        hidden: !isOpen || menuItems.length === 0,
        tabIndex: 0,
        onKeyDown: inputProps.onKeyDown,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ComboboxStyles.List, _objectSpread({}, menuProps, {
          role: 'list',
          children: menuItems.map(function (item, index) {
            var itemProps = getItemProps({
              item: item,
              index: index
            });
            var headerProps = getHeaderProps({
              item: item,
              index: index
            });
            if (item.section && shouldRenderSectionHeader(item)) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(SectionHeader, _objectSpread({}, headerProps, {
                "data-cy": (0, _useMultiComboboxController.getSectionDataCy)(dataCy, item)
              }), "".concat(item).concat(index));
            } else if (!item.section && headerProps.sectionVisible) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Option.ListItem, _objectSpread({
                isFocused: elementHasFocus(index)
              }, itemProps, {
                "data-cy": (0, _useMultiComboboxController.getItemDataCy)(dataCy, 'item', item),
                children: itemRenderer && item && itemRenderer(item, {
                  isSelection: false
                })
              }), "".concat(item).concat(index));
            } else {
              return null;
            }
          })
        }))
      })]
    })
  });
}
MultiCombobox.WIDTH = _input.TextFieldWidth;
MultiCombobox.HEIGHT = _input.TextFieldSize;
var _default = exports.default = MultiCombobox;